/**
 * Lightweight logger that proxies to console.* in development and goes
 * silent in production builds. Avoids leaking internal state to end users
 * (DevTools console clutter) and skips the formatting cost of console.*
 * calls on hot paths.
 *
 * Usage:
 *   import { log } from "@/lib/log";
 *   log.warn("[Module] something went sideways:", err);
 */
const isProd = process.env.NODE_ENV === "production";

export const log = {
  log: (...a) => { if (!isProd) console.log(...a); },
  info: (...a) => { if (!isProd) console.info(...a); },
  warn: (...a) => { if (!isProd) console.warn(...a); },
  debug: (...a) => { if (!isProd) console.debug(...a); },
  // Errors always surface so production monitoring can pick them up.
  error: (...a) => console.error(...a),
};
